import { ScrollArea } from '@/components/shadcn/scroll-area'
import { ComponentHeader } from '../shared/ComponentHeader'
import { ComponentTitle } from '../shared/ComponentTitle'
import clsx from 'clsx'
import { ComponentActionsContainer } from '../shared/ComponentActionsContainer'
import { getComponentHeights } from '../utils'
import { StepperComponentDataSchema, StepperComponentUISchema } from './types'
import { StepperComposed } from './components/StepperComposed'
import { Button } from '@/components/shadcn/button'
import { useSubmitForm } from '../FormComponent/useSubmitForm'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { IconMinusOutline } from '@icons/IconMinusOutline'
export function StepperComponentContent({
  uiSchema,
  dataSchema,
  tileFilters,
}: {
  uiSchema: StepperComponentUISchema
  dataSchema: StepperComponentDataSchema
  tileFilters?: React.ReactNode
}) {
  const { title = undefined, description = undefined, emphasizeHeader, ...rest } = uiSchema
  const { changeStepsHandlerId, canChangeSteps, stepsConfig } = rest
  const { currentStep, steps } = dataSchema
  const hasHeader = !!title && !!tileFilters
  const { contentHeight } = getComponentHeights(emphasizeHeader, hasHeader)
  return (
    <div className="flex h-full flex-col">
      {hasHeader && (
        <ComponentHeader>
          <ComponentTitle title={title} description={description} />
          <ComponentActionsContainer>
            {changeStepsHandlerId && canChangeSteps && (
              <SetStepsAction
                currentStep={currentStep}
                numberOfSteps={stepsConfig?.length ?? 0}
                changeStepsHandlerId={changeStepsHandlerId}
              />
            )}
            {tileFilters}
          </ComponentActionsContainer>
        </ComponentHeader>
      )}
      <ScrollArea className={clsx({ 'pt-5': hasHeader })} style={{ height: contentHeight }}>
        <div className="p-4">
          <StepperComposed {...rest} currentStep={currentStep} steps={steps} />
        </div>
      </ScrollArea>
    </div>
  )
}

function SetStepsAction({
  currentStep,
  numberOfSteps,
  changeStepsHandlerId,
}: {
  currentStep: number
  numberOfSteps: number
  changeStepsHandlerId: string
}) {
  const { mutate: submitForm } = useSubmitForm(changeStepsHandlerId, [])
  if (numberOfSteps <= 1) return null
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="icon"
        className="size-6"
        disabled={currentStep <= 1}
        onClick={() => submitForm({ action: 'decrement' })}
      >
        <IconMinusOutline />
      </Button>
      <Button variant="outline" size="sm" className="h-6" onClick={() => submitForm({ action: 'reset' })}>
        Reset Steps
      </Button>
      <Button
        variant="outline"
        size="icon"
        className="size-6"
        disabled={currentStep >= numberOfSteps + 1}
        onClick={() => submitForm({ action: 'increment' })}
      >
        <IconPlusOutline />
      </Button>
    </div>
  )
}
